import d from "./highrise1607.mjs";
import V from "./highrise648.mjs";
import j from "./highrise1328.mjs";
import y from "./highrise1313.mjs";
import c from "./highrise653.mjs";
import g from "./highrise1457.mjs";
import O from "./highrise643.mjs";
import C from "./highrise1462.mjs";
import M from "./highrise654.mjs";
import P from "./highrise1460.mjs";
import w from "./highrise656.mjs";
import x from "./highrise1463.mjs";
import D from "./highrise1465.mjs";
import b from "./highrise1609.mjs";
import F from "./highrise1476.mjs";
function U(t, p, o, v, A, l, f) {
  var i = b(t, o), e = b(p, o), s = f.get(e);
  if (s) {
    d(t, o, s);
    return;
  }
  var r = l ? l(i, e, o + "", t, p, f) : void 0, m = r === void 0;
  if (m) {
    var a = O(e), n = !a && M(e), u = !a && !n && D(e);
    r = e, a || n || u ? O(i) ? r = i : C(i) ? r = y(i) : n ? (m = !1, r = V(e, !0)) : u ? (m = !1, r = j(e, !0)) : r = [] : x(e) || g(e) ? (r = i, g(i) ? r = F(i) : (!w(i) || P(i)) && (r = c(e))) : m = !1;
  }
  m && (f.set(e, r), A(r, e, v, l, f), f.delete(e)), d(t, o, r);
}
export {
  U as default
};
